import { endpoints } from "../config";
import { getData } from "./api-utils";

const getStat = async () => {
  return await getData(endpoints.stat);
};

const getProgress = async () => {
  return await getData(endpoints.progress);
};

const getLog = async (biletId, themeId, type) => {
  return await getData(
    endpoints.log +
      "?" +
      `${type ? `type=${Number(type)}` : ""}${
        !!biletId ? `&biletId=${Number(biletId)}` : ""
      }${!!themeId ? `&themeId=${Number(themeId)}` : ""}`
  );
};

export { getStat, getProgress, getLog };
